export function getUsdExchange(state) {
   return state.usdExchange;
}

export function getUdis(state) {
   return state.udis;
}